const take = state => state.take
const tree = state => state.tree
const loading = state => state.loading
const dataset = state => state.dataset
const datasets = state => state.datasets
const lastUpdate = state => state.lastUpdate
const refreshing = state => state.refreshing
const withTrashed = state => state.withTrashed
const cacheParams = state => state.cacheParams
const importables = state => state.importables

export default {
  take,
  tree,
  loading,
  dataset,
  datasets,
  refreshing,
  lastUpdate,
  cacheParams,
  withTrashed,
  importables
}
